import React from "react";
import { Space, Row, Col } from "antd";
import EditableHoursTable from "../Tables/EditableHoursTable";
import useQueryGetHours from "../Api/useQueryGetHours";
import isLoading from "helperFunctions/_common/isLoading";
import { TablePaginationConfig } from "antd/lib/table";
import OrganizationsSearchbar from "../Searchbars/OrganizationsSearchbar";
import { Organization } from "@secondcloset/types/src/_common";

const PAGE_SIZE = 10;

function SpecialProjectHoursPanel() {
  const [selectedOrganization, setSelectedOrganization] = React.useState<Organization | undefined>(undefined);

  const [page, setPage] = React.useState(1);
  const { resolvedData, status } = useQueryGetHours("special-projects", page, PAGE_SIZE, {
    organizationIds: selectedOrganization?.id,
  });

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const nextPage = pagination.current || page;
    setPage(nextPage);
  };

  const loading = isLoading([status]);

  function onSelect(organization?: Organization) {
    setSelectedOrganization(organization);
  }

  return (
    <Space style={{ width: "100%" }} size="large" direction="vertical">
      <OrganizationsSearchbar style={{ width: 400 }} dropdownMatchSelectWidth={400} onSelect={onSelect} />

      <Row>
        <Col span={24}>
          <EditableHoursTable
            type="special-projects"
            rows={resolvedData?.data || []}
            columns={[
              {
                title: "Organization",
                dataIndex: ["organization", "name"],
              },
            ]}
            onChange={handleTableChange}
            loading={loading}
            pagination={{
              current: page,
              pageSize: PAGE_SIZE,
              total: resolvedData?.meta?.data.total || 0,
            }}
          />
        </Col>
      </Row>
    </Space>
  );
}

export default SpecialProjectHoursPanel;
